//
import Model from '@/models/Model'
import SaleCreditNoteModel from '@/models/Sale/SlSaleCreditNote'
import SaleDebitNoteModel from '@/models/Sale/SlSaleDebitNote'
import SaleInvoiceModel from '@/models/Sale/SlSaleInvoice'
import SaleTicketModel from '@/models/Sale/SlSaleTicket'

/**
 * @description
 * This class describes a sale tax document.
 *
 * @class      SlTaxDocument (name)
 */
export default class SlTaxDocument extends Model {

  /**
   * @description
   * SlTaxDocument Includes
   */
  static includes = ['sl_customer']

  /**
   * @description
   * { property_description }
   *
   * @type       {boolean}
   */
  get can_change_accounting_sale() {
    return this.alias !== 'BOLETA'
  }

  /**
   * @description
   * SlCustomer rut
   *
   * @type       {<type>}
   */
  get has_accounting_date() {
    return !! this.accounting_date
  }

  /**
   * Fetches a sale document.
   *
   * @return     {<type>}  The sale document.
   */
  fetchSaleDocument() {
    switch (this.type_code) {
      case 'boleta_electrónica' : return this.fetchSaleTicket()
      case 'factura_electrónica': return this.fetchSaleInvoice()
      case 'nota_de_crédito'    : return this.fetchSaleCreditNote()
      case 'nota_de_débito'     : return this.fetchSaleDebitNote()
    }
  }

  /**
   * Fetches a sale credit note.
   *
   * @return     {<type>}  The sale credit note.
   */
  fetchSaleCreditNote() {
    return SaleCreditNoteModel.find(this.id)
  }

  /**
   * Fetches a sale debit note.
   *
   * @return     {<type>}  The sale debit note.
   */
  fetchSaleDebitNote() {
    return SaleDebitNoteModel.find(this.id)
  }

  /**
   * Fetches a sale invoice.
   *
   * @return     {<type>}  The sale invoice.
   */
  fetchSaleInvoice() {
    return SaleInvoiceModel
      .include([
        'g_state',
        'sl_customer',
        'sl_detail_sale_invoices.wh_product',
      ])
      .find(this.id)
  }

  /**
   * Fetches a sale ticket.
   *
   * @return     {<type>}  The sale invoice.
   */
  fetchSaleTicket() {
    return SaleTicketModel.find(this.id)
  }

  /**
   * @description
   * Resets the object.
   *
   * @return     {Object}  { description_of_the_return_value }
   */
  reset() {

    //
    this.new_accounting_date = this.accounting_date

    //
    return this
  }

  /**
   * @description
   * SlTaxDocument Resource
   *
   * @return     {string}  endpoint model name
   */
  resource() {
    return 'sl_tax_document'
  }

  /**
   * { property_description }
   * @type       {<type>}
   */
  get sl_customer_branch_offices_address() {
    return this.getProperty('sl_customer_branch_offices.address', '-')
  }

  /**
   * @description
   * SlCustomer bussines_name
   *
   * @type       {<type>}
   */
  get sl_customer_business_name() {
    return this.getProperty('sl_customer.business_name', '-')
  }

  /**
   * @description
   * SlCustomer rut
   *
   * @type       {<type>}
   */
  get sl_customer_rut() {
    return this.getProperty('sl_customer.rut', '')
  }

  /**
   * { property_description }
   *
   * @type       {<type>}
   */
  get type_code() {
    return String(this.type || '')
      .toLowerCase()
      .split(' ')
      .join('_')
  }
}
